import { useState, useEffect, MouseEvent } from 'react';
import checkRedFill from 'public/static/images/check-red-fill.svg';
import { screen } from 'components/styles/variables';
import classnames from 'classnames';
import styles from './styles';

interface LabeledCheckBoxProps {
  label: string;
  onClick: (value: boolean, event: MouseEvent<HTMLButtonElement>) => void;
  isChecked?: boolean;
}

export default function LabeledCheckBox({
  label,
  onClick,
  isChecked: initialIsChecked = false,
}: LabeledCheckBoxProps): JSX.Element {
  const [isChecked, setIsChecked] = useState(initialIsChecked);
  useEffect(() => {
    setIsChecked(initialIsChecked);
  }, [initialIsChecked]);

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onClick(newValue, event);
  };

  return (
    <button className="checkbox-with-label-container" onClick={handleClick}>
      <div
        data-testid="search-filter-checkbox"
        className={classnames('checkbox', isChecked ? 'checkbox-checked' : 'checkbox-unchecked')}
      />
      <span className="checkbox-label">{label}</span>
      <style jsx>{styles}</style>
      <style jsx>{`
        .checkbox-with-label-container {
          display: flex;
          align-items: center;
          height: 44px;
          padding: 10px 16px;
          cursor: pointer;
          background: none;
          color: inherit;
          border: none;
          font: inherit;
          cursor: pointer;
          outline: inherit;
        }

        .checkbox-label {
          margin-left: 16px;
          font-size: 14px;
        }

        @media (min-width: ${screen.smMin}) and (hover: hover) and (pointer: fine) {
          .checkbox-with-label-container {
            width: 100%;
          }

          .checkbox-with-label-container:hover .checkbox-unchecked {
            background-image: url(${checkRedFill});
            background-size: cover;
          }
        }
      `}</style>
    </button>
  );
}
